// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

export default function BlockContent() {
  const { translate } = useLocales();
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ py: 3 }}>
        <Typography gutterBottom variant="h5" sx={{ fontSize: '15px !important' }}>
          {translate('drop_or_select_file')}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px !important' }}>
          {/* Drop files here or click&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline', fontSize: '12px !important' }}
          >
            browse
          </Typography>
          &nbsp;thorough your machine */}
          {translate('drop_files_here')}
        </Typography>
      </Box>
    </Stack>
  );
}
